import { Card, Col, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { AiOutlineFile } from "react-icons/ai";
import { BiBody, BiPhone } from "react-icons/bi";
import { FaWeight } from "react-icons/fa";
import { GiAges, GiBodyHeight } from "react-icons/gi";
import { GoMail } from "react-icons/go";
import { HiOutlineIdentification } from "react-icons/hi";
import { IoLocationOutline } from "react-icons/io5";
import { RiShieldCheckLine } from "react-icons/ri";
import { checkSpecialityToShowIMC } from "../../utils/checkSpecialityToShow";

function DetalleCitaPaciente({t, cita, companyType}){

    return(
        <Card className="shadow-1">
            <Card.Body>
                <h6>{`${cita.patientDTO.name} ${cita.patientDTO.middleName ?? ''} ${cita.patientDTO.lastName} ${cita.patientDTO.seccondSurname ?? ''}`}</h6>
                <Row>
                    <Col xs="12" md="8">
                        {
                            (companyType==='colombia') && 
                            <div className="d-flex text-secondary mb-3 font-size-09rem">
                                <div><HiOutlineIdentification className="mr-2"/></div>
                                <div><span>{cita.patientDTO?.identityDocumentType?.code}: {cita.patientDTO.documentNumber}</span></div>                                            
                            </div>
                        }
                        <div className="d-flex text-secondary mb-3 font-size-09rem">
                            <div><BiPhone className="mr-2"/></div>
                            <div><span>{cita.patientDTO?.phone}</span></div>                                            
                        </div>
                        <div className="d-flex text-secondary mb-3 font-size-09rem">
                            <div><GoMail className="mr-2"/></div>
                            <div><span>{cita.patientDTO?.email}</span></div>
                        </div>
                        {
                            (companyType==='colombia') ?
                            <div className="d-flex text-secondary mb-3 font-size-09rem">
                                <div><IoLocationOutline className="mr-2"/></div>
                                <div>
                                <span className="d-block">
                                    {cita.patientDTO?.colombusAddress?.roadType?.name} {cita.patientDTO?.colombusAddress?.streetField1} {cita.patientDTO?.colombusAddress?.streetField2} {cita.patientDTO?.colombusAddress?.streetField3}
                                </span>
                                <span className="d-block">
                                    {cita.patientDTO?.colombusAddress?.propertyType?.name} {cita.patientDTO?.colombusAddress?.unitNumber} {cita.patientDTO?.colombusAddress?.propertyTypeAdditional?.name} {cita.patientDTO?.colombusAddress?.propertyNumber}
                                </span>
                                </div>                                            
                            </div> : 
                            <div className="d-flex text-secondary mb-3 font-size-09rem">
                                <div><IoLocationOutline className="mr-2"/></div>
                                <div><span>{cita.patientDTO?.address}</span></div>                                            
                            </div>
                        }
                        <div className="d-flex text-secondary mb-3 font-size-09rem">
                            <div><AiOutlineFile className="mr-2"/></div>
                            <div><span>{t('no_expediente')}: {cita?.expediente}</span></div>                                            
                        </div>
                        <div className="d-flex text-secondary mb-3 font-size-09rem">
                            <div><GiAges className="mr-2"/></div>
                            <div><span>Edad: {
                                !cita.ageDTO ? '-' :
                                cita.ageDTO?.years < 1 ? 
                                cita.ageDTO.months < 1 ?
                                `${cita.ageDTO.days} ${cita.ageDTO.days === 1 ? 'día' : 'días'}` :
                                `${cita.ageDTO.months} ${cita.ageDTO.months === 1 ? 'mes' : 'meses'}` :
                                `${cita.ageDTO?.years} ${cita.ageDTO?.years === 1 ? 'año' : 'años'}` 
                            }</span></div>
                        </div>
                    </Col>
                    <Col xs="12" md="4">                            
                        <div className="d-flex text-secondary mb-3 font-size-09rem">
                            <div><RiShieldCheckLine className="mr-2"/> </div>
                            <div><span>{cita.patientDTO?.account != null ? cita.patientDTO?.account?.name : '' }</span></div>                                            
                        </div>
                        {
                            (cita.peso && checkSpecialityToShowIMC(cita)) && 
                            <div className="d-flex text-secondary mb-3 font-size-09rem">
                                <div><FaWeight className="mr-2"/></div>
                                <div><span>{cita?.peso != null ? cita?.peso : '-' } Kg</span></div>                                            
                            </div>
                        }
                        {
                            (cita.talla && checkSpecialityToShowIMC(cita)) && 
                            <div className="d-flex text-secondary mb-3 font-size-09rem">
                                <div><GiBodyHeight className="mr-2"/></div>
                                <div><span>{cita?.talla != null ? cita?.talla : '-' } cm</span></div>                                            
                            </div>
                        }
                        {
                            (cita.peso && cita.talla && checkSpecialityToShowIMC(cita)) && 
                            <div className="d-flex text-secondary mb-3 font-size-09rem">
                                <div><BiBody className="mr-2"/></div>
                                <div><span>IMC: {(cita?.imc != null && cita?.imc !== 'NaN') ? cita?.imc.toFixed(2) : '-' }</span></div>
                            </div>
                        }
                    </Col>
                    <Col xs="12" md="12">
                        <Card>
                            <Card.Body>
                                <label className="text-secondary d-block mb-0">Motivo de consulta</label>
                                <label className="m-0 text-secondary">{`${cita?.motivoConsulta ? cita.motivoConsulta : 'Sin motivo'}`}</label>
                            </Card.Body>
                        </Card> 
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )

}

export default withTranslation()(DetalleCitaPaciente)